module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("88KZ5"))).then(() => parcelRequire('hEqeo'));